export default __webpack_public_path__ + "static/media/clock.dc0b5de5.png";